import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule, Title} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {PlanningRegionComponent} from './layout/pages/planning-region/planning-region.component';
import {LayoutComponent} from './layout/layout.component';
import {HeaderComponent} from './layout/header/header.component';
import {NgbDateParserFormatter, NgbDropdownConfig, NgbModule, NgbTypeaheadConfig} from '@ng-bootstrap/ng-bootstrap';
import {AppRoutingModule} from "./app-routing.module";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {APP_BASE_HREF, registerLocaleData} from "@angular/common";
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {MatDialogModule} from "@angular/material/dialog";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ProgressSpinnerComponent} from "./shared/progress-spinner/progress-spinner.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {ToastsComponent} from "./shared/toasts/toasts.component";
import localeFr from '@angular/common/locales/fr';
import {CustomDateParserFormatter} from "./services/custom-date-parser-formatter.service";
import {AuthInterceptor} from "./httpconfig/httpconfig.interceptor";
import {
  PlanningRegionCellComponent
} from "./layout/pages/planning-region/planning-region-week/planning-region-row/planning-region-cell/planning-region-cell.component";
import {
  PlanningRegionEmptyCellComponent
} from "./layout/pages/planning-region/planning-region-week/planning-region-row/planning-region-empty-cell/planning-region-empty-cell.component";
import {
  PlanningRegionActionsComponent
} from "./layout/pages/planning-region/planning-region-actions/planning-region-actions.component";
import {
  PlanningRegionHeaderComponent
} from "./layout/pages/planning-region/planning-region-header/planning-region-header.component";
import {
  PlanningRegionRowComponent
} from "./layout/pages/planning-region/planning-region-week/planning-region-row/planning-region-row.component";
import {
  PlanningRegionWeekComponent
} from "./layout/pages/planning-region/planning-region-week/planning-region-week.component";

export function httpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/");
}

registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent,
    PlanningRegionComponent,
    LayoutComponent,
    HeaderComponent,
  ],
  imports: [
    MatProgressSpinnerModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
      defaultLanguage: "fr-FR",
    }),
    ProgressSpinnerComponent,
    ToastsComponent,
    FormsModule,
    PlanningRegionCellComponent,
    PlanningRegionEmptyCellComponent,
    PlanningRegionActionsComponent,
    PlanningRegionHeaderComponent,
    PlanningRegionRowComponent,
    PlanningRegionWeekComponent,
  ],
  bootstrap: [AppComponent],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {provide: APP_BASE_HREF, useValue: "/"},
    NgbDropdownConfig,
    NgbTypeaheadConfig,
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter},

    Title,
    {provide: LOCALE_ID, useValue: "fr-FR"},
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
export class AppModule {
}
